export default "__VITE_ASSET__DK1XM7fn__"